import {
  mapFileMetadataDtoToFileMetadataModel,
  mapPlatformDtoToPlatformModel,
} from '../../shared/utils/mapping/mapping.utils';
import { ReleaseRequestDto } from '../dtos/release-request.dto';
import { ReleaseDto } from '../dtos/release.dto';
import { ReleaseRequestModel } from '../models/release-request.model';
import { ReleaseModel } from '../models/release.model';
import { appPlatformsAdapter } from './app-platforms-adapter.util';

export function mapReleaseDtoToReleaseModel(
  releaseDto: ReleaseDto
): ReleaseModel {
  return {
    androidMinSDKVersion: releaseDto?.androidMinSDKVersion,
    androidMaxSDKVersion: releaseDto?.androidMaxSDKVersion,
    androidPackage: releaseDto?.androidPackage,
    apkFiles: releaseDto?.apkFiles.map(mapFileMetadataDtoToFileMetadataModel),
    description: releaseDto?.description,
    id: releaseDto?.id,
    platforms: releaseDto?.platforms?.map(mapPlatformDtoToPlatformModel),
    formattedPlatforms: appPlatformsAdapter(releaseDto?.platforms),
    status: releaseDto?.status,
    updateDate: releaseDto?.updateDate,
    versionCode: releaseDto?.versionCode,
    versionName: releaseDto?.versionName,
    sizeInBytes: releaseDto?.sizeInBytes,
  };
}

export function mapReleaseRequestModelToReleaseRequestDto({
  apkFilesIds,
  description,
  status,
}: ReleaseRequestModel): ReleaseRequestDto {
  return {
    apkFilesIds,
    description,
    status,
  };
}
